import React from 'react'
import { LinkButton } from '../../../components/Button/LinkButton'
import { useGetMeQuery } from '../../../store/user/user'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useCookies } from 'react-cookie'
import './CrossClientWaitlist.scss'

const ALREADY_ON_CCQ_WAITLIST_COOKIE_MAX_AGE = 60 * 60 * 24 * 30 * 6

export const CrossClientWaitlist: React.FC = () => {
  const accountId = useAppSelector(selectAccountId)

  const [cookies, setCookie] = useCookies(['alreadyOnCcqWaitlist'])

  const { data: currentUser } = useGetMeQuery({ accountId })

  if (!currentUser) {
    return null
  }

  return (
    <div className='d-flex flex-column align-items-center zocks-gap-4 mt-2'>
      <div className='cross-client-waitlist-video-container'>
        <video
          src='https://static.zocks.io/assets/ccq/ccq_teaser.mp4'
          className='w-100 cross-client-waitlist-video zocks-border-0.5'
          controls
          muted
          autoPlay
          playsInline
          preload='metadata'
        />
      </div>
      <div className='d-flex flex-column gap-4 align-items-center px-3'>
        <div className='d-flex flex-column zocks-gap-0.75 align-items-center'>
          <div className='h2 text-center'>From question to client list in minutes</div>
          <div className='paragraph-large text-center cross-client-waitlist-content-container'>
            Ask who you're looking for in plain English. Get an actionable list of clients. No spreadsheets, filters, or manual searching required.
          </div>
        </div>
        <div className='d-flex align-items-center'>
          {!cookies.alreadyOnCcqWaitlist ? (
            <LinkButton
              variant='primary'
              className='px-4 zocks-py-0.75 zocks-border-0.5'
              to={`https://ljn4s9vaxf9.typeform.com/to/tRBZ7a8A#email=${encodeURIComponent(currentUser.email)}&user_id=${encodeURIComponent(currentUser.id)}`}
              target='_blank'
              rel='noopener noreferrer'
              onClick={() => setCookie('alreadyOnCcqWaitlist', true, { path: '/', maxAge: ALREADY_ON_CCQ_WAITLIST_COOKIE_MAX_AGE })}
            >
              Join the waitlist
            </LinkButton>
          ) : (
            <div className='paragraph-medium text-center zocks-text-gray-600'>Thanks for joining the waitlist! We'll be in touch.</div>
          )}
        </div>
        <div className='d-flex flex-column align-items-center paragraph-medium text-center zocks-text-gray-600'>
          <span>Rolling out soon to selected customers.</span>
          <span>Reserve your spot for early access.</span>
        </div>
      </div>
    </div>
  )
}
